import { useEffect, useRef } from 'react';

const updateImageLinksToProductUrl = (element, productUrl, affiliateDataAttributes) => {
  if (!productUrl) {
    return;
  }

  element.href = productUrl;
  for (const [attrName, attrValue] of Object.entries(affiliateDataAttributes)) {
    element.setAttribute(attrName, attrValue);
  }
  element.setAttribute('data-product-link', 'true');
};

export function useProductImageHref({ buzz = {} }) {
  const ref = useRef(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    const affiliateLink = element.querySelector('a[data-affiliate]');
    if (!affiliateLink) {
      return;
    }

    const affiliateDataAttributes = Array.from(affiliateLink.attributes)
      .filter(attr => attr.name.startsWith('data-'))
      .reduce((acc, attr) => {
        acc[attr.name] = attr.value;
        return acc;
      }, {});

    // handle single image for old shopping posts
    element.querySelectorAll('a[data-type="click-single-image"]:not([data-product-link])').forEach(link => {
      // make sure the image is clickable
      const disabledClass= Array.from(link.classList).find(className => className.startsWith('image__link--disabled'));
      if (disabledClass) {
        link.classList.remove(disabledClass);
      }
    });

    // handle photo sets for old shopping posts
    element.querySelectorAll('a[data-type="click-photoset-item"]:not([data-product-link])').forEach(link => {
      updateImageLinksToProductUrl(link, affiliateLink.href, affiliateDataAttributes);
    });
  }, []);

  return ref;
}
